import { configService } from "@/infrastructure/services/ConfigService";
/**
 * Whether the document module serves its in-memory fixtures instead of the BFF.
 *
 * Both conditions are required, and the dev-build gate is the safety half: the runtime
 * `config.json` fetch is swallowed with a debug log and falls through to the build-time
 * `VITE_API_BFF_URL`, which a config-driven production image leaves unset — without the
 * gate, that config miss would silently serve fabricated documents and discard every
 * write. In a production build a missing BFF URL must fail loudly on the real call.
 *
 * The OnlyOffice URL is deliberately NOT part of the gate: `OfficeEditor.vue`
 * renders its own "unavailable" panel when the editor is unconfigured, and gating on it
 * here would send every upload to the in-memory mock, vanishing files on refresh.
 */
export function isStubMode() {
    return computeStubMode(import.meta.env.DEV, configService.api?.bffUrl);
}
/** Pure decision half of {@link isStubMode}, split out so both axes are testable. */
export function computeStubMode(isDevBuild, bffUrl) {
    return isDevBuild && !bffUrl;
}
